import { useMutation } from '@apollo/client';
import { graphql } from '../graphql';
import { useErrorState } from '../stores/useErrorState';
export const CLOSE_CASE = graphql(`
  mutation CloseCase {
    closeCase
  }
`);
export const useCloseConversation = () => {
    const [closeCase] = useMutation(CLOSE_CASE);
    const { setErrorState } = useErrorState();
    return () => closeCase()
        .then(result => {
        var _a;
        return (_a = result.data) === null || _a === void 0 ? void 0 : _a.closeCase;
    })
        .catch(err => setErrorState({
        code: err.name,
    }));
};
//# sourceMappingURL=useCloseConversation.js.map